import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

const httpSpaceOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }),
};

const httpFileDownloadHttOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    observe: 'response',
    responseType: 'blob',
    accept: '*',
  }),
};

@Injectable()
export class SandboxService {
  baseUrl: string = '';

  httpOptions: any;

  //Services
  _datePipe = inject(DatePipe);

  constructor(private http: HttpClient) {
    this.baseUrl = environment.spaceEngineRestServer;
  }

  getPdfTestMiInvoice(invoiceNumber: string, lotNumber: string, entityId: string) {
    return this.http.get(`${this.baseUrl}invoice/invoicepdfmi/${invoiceNumber}/${lotNumber}/${entityId}`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  getPdfTestGbInvoice(invoiceNumber: string, lotNumber: string) {
    return this.http.get(`${this.baseUrl}invoice/invoicepdfgb/${invoiceNumber}/${lotNumber}`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  private handleError(error: HttpErrorResponse) {
    console.error('handleErrorHttpRequest', error);
    if (error.error instanceof Error) {
      console.error('Error thrown: ' + JSON.stringify(error));
      const errMessage = error.error.message;
      return throwError(() => errMessage);
      // Use the following instead if using lite-server
      // return Observable.throw(err.text() || 'backend server error');
    }
    return throwError(() => error || 'server error');
  }
}
